import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { api_gateway } from '../../conexoes/api'
import simboloVirtueyes from '../../icones/_novoPadrao/simbolo-virtueyes.svg'
import logoVirtueyesPreto from '../../icones/iconesVersaoClara/logo-virtueyes-preto.svg'
import logoVirtueyesBranco from '../../icones/iconesVersaoEscura/logo-virtueyes-branco.svg'
import minimizarIcon from '../../icones/minimizar-icon.png'
import '../../css/navegacaoSistema.css'
import {
  expandirNavegacao,
  expandirNavegacaoHover,
  imagemPerfil,
  mudarBreadCrumbs,
  mudarPermissaoElemento,
  mudarPermissaoElementoAcao,
  mudarPermissaoElementoOutrosConfiguracoesConfigurarGrupos,
  mudarPermissaoElementoOutrosConfiguracoesExibirColunas,
  mudarPermissaoElementoOutrosInformacoesConsultarCobertura,
  mudarPermissaoElementoOutrosMensagensVisualizarMensagens
} from '../../redux/actions/index'
import { useGlobal } from '../../stores/useGlobal'
import { setaBranca } from '../../utils/alternanciaIcones'
import decryptJWT from '../../utils/decryptJWT'
import utilsLocalStorage from '../../utils/localStorage'
import { isPortal } from '../../utils/nivelCliente.js'
import { validadorPermissaoElemento } from '../../utils/verificadorPermissaoElemento'
import { getTitulosPaginas } from '../BreadCrumbs/tituloPaginas'
import InfoUsuario from '../componentesModais/infoUsuario'
import { IconeSeta } from '../componentesModais/infoUsuario/styles'
import { RenderMensagemInformacao } from '../componentesModais/mensagens/mensagemInformacao.js'
import MenuNavLinks from '../Mantine/NavLink'
import Tutoriais from '../painelTutoriais'
import AlterarLogin from '../perfilUsuario/alterarLogin'
import AlterarSenha from '../perfilUsuario/alterarSenha/index.jsx'
import DadosConta from '../perfilUsuario/dadosConta'
import PerfilUsuario from '../perfilUsuario/perfil'

const clientesSemChat = ['600000', '410656']

function ContainerModalAcao({ children }) {
  return (
    <div className="componente-modal-overlay">
      <div className="componente-modal">{children}</div>
    </div>
  )
}

function NavegacaoSistema(props) {
  const [revelarInfosUsuario, setRevelarInfosUsuario] = useState(false)
  const [menuExpandido, setMenuExpandido] = useState(true)
  const [menuBarraRecolhida, setMenuBarraRecolhida] = useState(false)
  const [renderizar, setRenderizar] = useState(false)
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [contadorNovidadesNaoLidas, setContadorNovidadesNaoLidas] = useState(0)
  const [localTema, setLocalTema] = useState(localStorage.getItem('tema'))
  const toggleTema = useGlobal((state) => state.toggleTema)

  useEffect(() => {
    setLocalTema(localStorage.getItem('tema'))
  }, [toggleTema])

  useEffect(() => {
    window.veyeAltubotsDefinirIconeMinimizar?.(minimizarIcon)
  }, [])

  let imagem = useSelector((state) => state.manejadorState.imagemPerfil)
  let revelarMenuTutorial = useSelector(
    (state) => state.manejadorState.revelarTutorial
  )
  let atualizarAlertaCabecalho = useSelector(
    (state) => state.mensagensState.atualizarAlertaCabecalho
  )

  const manejador = useSelector((state) => state.manejadorState.manejador)

  const portalCliente = isPortal()

  const getFlChat = localStorage.getItem('fl_chat')
  const flChat = getFlChat === '1' && !portalCliente

  const codigoErpAntigo = decryptJWT('codigoClienteErpAntigo')

  const token = localStorage.getItem('@veye-Token')

  const chatDisponivel = Boolean(
    token && flChat && !clientesSemChat.includes(codigoErpAntigo)
  )

  useEffect(() => {
    const aplicarVisibilidadeChat = () => {
      const chatElements = document.getElementsByClassName(
        'smk-altu-button-chat'
      )

      if (chatElements.length > 0) {
        Array.from(chatElements).forEach((chatElement) => {
          if (chatDisponivel) {
            chatElement.style.display = 'block'
          } else {
            chatElement.style.display = 'none'
          }
        })
      }
    }

    aplicarVisibilidadeChat()

    const observer = new MutationObserver(aplicarVisibilidadeChat)
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    return () => observer.disconnect()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatDisponivel])

  const despacho = useDispatch()
  let estadoExpansaoNavegacao = useSelector(
    (state) => state.manejadorState.expandirNavegacao
  )
  const menuLateralExpandido = estadoExpansaoNavegacao === true

  useEffect(() => {
    despacho(mudarPermissaoElementoAcao(false))
    despacho(expandirNavegacaoHover(menuExpandido))
  }, [despacho])

  function expandeMenu() {
    if (
      estadoExpansaoNavegacao === false &&
      menuExpandido === true &&
      menuBarraRecolhida === false
    ) {
      despacho(expandirNavegacao(!estadoExpansaoNavegacao))
      setMenuExpandido(false)
      setMenuBarraRecolhida(true)
    }
  }

  function recolheMenu() {
    if (
      menuLateralExpandido &&
      menuExpandido === false &&
      menuBarraRecolhida === true
    ) {
      despacho(expandirNavegacao(!estadoExpansaoNavegacao))
      setMenuExpandido(true)
      setMenuBarraRecolhida(false)
    }
  }

  useEffect(() => {
    async function renderModulo() {
      setRenderizar(false)

      if (
        imagem === '' ||
        imagem === null ||
        !utilsLocalStorage.getUsuarioNomeCompleto()
      ) {
        await api_gateway
          .get('/m1/consultar/usuario?cd_pav_usuario=' + decryptJWT('codigo'))
          .then((resolve) => {
            if (resolve.data.status === 200 && resolve.data.dados.length != 0) {
              const objDados = resolve.data.dados[0]
              utilsLocalStorage.setUsuarioNomeCompleto(objDados)
              if (objDados.bl_imagem != null && objDados.bl_imagem != '') {
                despacho(imagemPerfil(objDados.bl_imagem))
              }
            }
          })
          .catch(function (error) {
            console.error(error)
          })
      }

      const pegarMenus = await api_gateway.post(
        '/m1/servicos/dados/permissao',
        {
          id: decryptJWT('id')
        }
      )

      if (pegarMenus.data.dados) {
        despacho(mudarBreadCrumbs(getTitulosPaginas(pegarMenus.data.dados)))

        const elementos = JSON.parse(JSON.stringify(pegarMenus.data.dados[3]))
        despacho(mudarPermissaoElemento(elementos))

        despacho(
          mudarPermissaoElementoOutrosConfiguracoesExibirColunas(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/configuracoes/exibirColunas'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosConfiguracoesConfigurarGrupos(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/configuracoes/configurarGrupos'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosInformacoesConsultarCobertura(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/informacoes/consultarCobertura'
            )
          )
        )
        despacho(
          mudarPermissaoElementoOutrosMensagensVisualizarMensagens(
            await validadorPermissaoElemento(
              elementos,
              'veye/outros/mensagens/visualizarMensagens'
            )
          )
        )
      }
    }
    renderModulo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderizar, localTema])

  function handleMensagemInformacao() {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
    }
  }

  useEffect(() => {
    if (!manejador) return
    buscaNovidadesNaoLidas()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manejador, atualizarAlertaCabecalho])

  async function buscaNovidadesNaoLidas() {
    const { data } = await api_gateway.get(
      '/m1/consultar/usuario_versionamento'
    )
    let lastReleaseNoteRead
    let lastReleaseNotes

    if (data?.status == 200) {
      const auxDadosNovidades = data?.dados
      if (auxDadosNovidades.length > 0) {
        const ultimaNovidade = auxDadosNovidades[0]
        lastReleaseNoteRead = ultimaNovidade.cd_pav_release_ultima_lida
        lastReleaseNotes = ultimaNovidade.cd_pav_release
        localStorage.setItem(
          'releaseNotes',
          JSON.stringify({ lastReleaseNotes, lastReleaseNoteRead })
        )
      }

      if (lastReleaseNotes > lastReleaseNoteRead) {
        setContadorNovidadesNaoLidas(auxDadosNovidades?.length) // mostrar alerta
      } else {
        // não mostrar alertas
        if (contadorNovidadesNaoLidas > 0) {
          setContadorNovidadesNaoLidas(0)
        }
      }
    }
  }

  return (
    <div className="fundo-cor-5">
      {props.revelarDadosContaUsuario && (
        <ContainerModalAcao>
          <DadosConta />
        </ContainerModalAcao>
      )}
      {props.revelarPerfilContaUsuario && (
        <ContainerModalAcao>
          <PerfilUsuario />
        </ContainerModalAcao>
      )}
      {props.revelarAlterarLogin && (
        <ContainerModalAcao>
          <AlterarLogin />
        </ContainerModalAcao>
      )}
      {props.revelarAlterarSenha && <AlterarSenha />}

      {revelarMensagemInformacao && (
        <RenderMensagemInformacao
          handleMensagemInformacao={handleMensagemInformacao}
          mensagemParagrafo1="Caro cliente, para melhor atende-lo, nosso FAQ está em processo de contrução, em breve teremos mais novidades."
          mensagemBotao="FECHAR"
        />
      )}

      {revelarMenuTutorial === true && (
        <div className="componente-modal-overlay-tutorial">
          <div className="componente-modal">
            <Tutoriais />
          </div>
        </div>
      )}

      <div
        className={
          menuLateralExpandido
            ? 'container-navegacao-sistema-1'
            : 'container-navegacao-sistema-2'
        }
      >
        <nav
          className="nav"
          onMouseEnter={() => expandeMenu()}
          onMouseLeave={() => recolheMenu()}
        >
          <Link to="/">
            <div className="container-logo-veye">
              <img
                key="logo-simbolo"
                alt="logo-vityueyes"
                className={
                  menuLateralExpandido
                    ? 'logo-virtueyes-simbolo-1'
                    : 'logo-virtueyes-simbolo-2'
                }
                src={simboloVirtueyes}
              />
              <img
                key={`logo-palavra-${localTema}`}
                alt="logo-virtueyes-palavra"
                className={
                  menuLateralExpandido
                    ? 'logo-virtueyes-palavra-1'
                    : 'logo-virtueyes-palavra-2'
                }
                src={localTema === 'escuro' ? logoVirtueyesBranco : logoVirtueyesPreto}
              />
            </div>
          </Link>
          <div
            className={
              menuLateralExpandido
                ? 'container-usuario-logado'
                : 'container-usuario-logado-2'
            }
          >
            {imagem != null && imagem != '' ? (
              <IconeUsuarioLogado src={imagem} alt='foto-usuario' />
            ) : (
              <IconeUsuarioLogado
                src="https://jazzaero.com.br/wp-content/uploads/2017/05/default-placeholder-profile-icon-avatar-gray-woman-90197997.jpg"
                alt="perfil"
              />
            )}
            <div
              className={
                menuLateralExpandido
                  ? 'container-dropdown-perfil-cabecalho-sistema'
                  : 'container-dropdown-perfil-cabecalho-sistema-2'
              }
            />
            <div
              className={
                menuLateralExpandido
                  ? 'container-usuario-logado-dados'
                  : 'container-usuario-logado-dados-2'
              }
            >
              <div
                className={
                  menuLateralExpandido
                    ? 'usuario-logado-dados-nome-1'
                    : 'usuario-logado-dados-nome-2'
                }
              >
                <div className="fonte-cor-1">{decryptJWT('nomeDeUsuario')}</div>
              </div>
              <p
                className={
                  menuLateralExpandido
                    ? 'usuario-logado-dados-email-1'
                    : 'usuario-logado-dados-email-2'
                }
              >
                {decryptJWT('email')}
              </p>
            </div>
            <button
              className={
                menuLateralExpandido
                  ? 'botao-expandir-infos-usuario'
                  : 'botao-expandir-infos-usuario-2'
              }
              onClick={() => setRevelarInfosUsuario(!revelarInfosUsuario)}
            >
              <IconeSeta
                revelarInfosUsuario={revelarInfosUsuario}
                src={setaBranca()}
                alt="seta"
              />
            </button>
            {revelarInfosUsuario === true && (
              <InfoUsuario setRevelarInfosUsuario={setRevelarInfosUsuario} />
            )}
          </div>
          <div
            className={
              menuLateralExpandido
                ? 'container-menus-navegacao'
                : 'container-menus-navegacao-1'
            }
          >
            <MenuNavLinks />
          </div>
        </nav>
      </div>
    </div>
  )
}

const IconeUsuarioLogado = ({ src, alt = '' }) => (
  <img className="icone-usuario-logado" src={src} alt={alt} />
)

function mapStateToProps(state) {
  return {
    revelarDadosContaUsuario: state.virtueyesState.revelarDadosContaUsuario,
    revelarPerfilContaUsuario: state.virtueyesState.revelarPerfilContaUsuario,
    revelarAlterarLogin: state.virtueyesState.revelarAlterarLogin,
    revelarAlterarSenha: state.virtueyesState.revelarAlterarSenha
  }
}

export default connect(mapStateToProps)(NavegacaoSistema)
